// The rest of the app reads auth state from sessionStorage everywhere
// (navbar, cart, tour-details, user-profile, ...), which is why signing in
// on one tab didn't carry over to a new one — sessionStorage is wiped the
// moment the tab/window closes. Rather than rewrite every one of those read
// sites, we keep sessionStorage as the single source of truth the rest of
// the app already relies on, and use localStorage only as a "remember me"
// backup that rehydrates sessionStorage on the next visit.

const TOKEN_KEY = "wat_token";
const USER_KEY = "userInfo";

// Called once, before the app renders, so a returning visitor who checked
// "keep me signed in" doesn't have to log in again just because they opened
// a new tab or reopened the browser.
export const hydrateSession = () => {
  try {
    if (sessionStorage.getItem(TOKEN_KEY)) return; // already signed in this tab
    const token = localStorage.getItem(TOKEN_KEY);
    const userInfo = localStorage.getItem(USER_KEY);
    if (token) {
      sessionStorage.setItem(TOKEN_KEY, token);
      if (userInfo) sessionStorage.setItem(USER_KEY, userInfo);
    }
  } catch {
    // storage unavailable (private browsing, etc.) - just skip remembering
  }
};

// Called after a successful login. Always writes sessionStorage (so
// existing reads keep working); additionally persists to localStorage when
// the visitor asked to be remembered.
export const persistToken = (token, remember) => {
  try {
    sessionStorage.setItem(TOKEN_KEY, token);
    if (remember) {
      localStorage.setItem(TOKEN_KEY, token);
    } else {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(USER_KEY);
    }
  } catch {
    // ignore - nothing to persist to
  }
};

export const persistUserInfo = (userInfo, remember) => {
  try {
    const raw = JSON.stringify(userInfo);
    sessionStorage.setItem(USER_KEY, raw);
    if (remember) localStorage.setItem(USER_KEY, raw);
  } catch {
    // ignore
  }
};

export const clearRememberedSession = () => {
  try {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  } catch {
    // ignore
  }
};
